const statusStyles: Record<string, string> = {
  received: 'bg-secondary-100 text-secondary-800',
  preparing: 'bg-accent-100 text-accent-800',
  ready: 'bg-green-100 text-green-800',
  served: 'bg-foreground-100 text-foreground-600',
  cancelled: 'bg-red-100 text-red-700',
  paid: 'bg-green-100 text-green-800',
  pending: 'bg-amber-100 text-amber-800',
  refunded: 'bg-red-100 text-red-700',
  delivered: 'bg-green-100 text-green-800',
};

interface StatusBadgeProps {
  status: string;
  label?: string;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, label, size = 'sm' }: StatusBadgeProps) {
  const style = statusStyles[status] || 'bg-background-200 text-foreground-600';
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap ${sizeClasses} ${style}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${getStatusDotColor(status)}`}></span>
      {label || capitalizeWords(status)}
    </span>
  );
}

function getStatusDotColor(status: string): string {
  const map: Record<string, string> = {
    received: 'bg-secondary-500',
    preparing: 'bg-accent-500',
    ready: 'bg-green-500',
    served: 'bg-foreground-400',
    cancelled: 'bg-red-500',
    paid: 'bg-green-500',
    pending: 'bg-amber-500',
    refunded: 'bg-red-500',
  };
  return map[status] || 'bg-foreground-400';
}

function capitalizeWords(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}